import { defineStore } from 'pinia';

type StoreStateType = {
	isKeepLogin?: boolean;
	member_nickname?: string;
	member_name?: string;
	member_join_path?: string;
	fcm_token?: string;
	device?: string;
	id?: string;
	group_pk?: number | null;
	group_sp?: number | null;
	user_img?: string;
};
export const useAuthStore = defineStore('auth', {
	state: (): StoreStateType => {
		return {
			isKeepLogin: false,
			member_nickname: '',
			member_name: '',
			member_join_path: '',
			fcm_token: '',
			device: '',
			id: '',
			group_pk: null,
			group_sp: null,
			user_img: '',
		};
	},
	getters: {
		getMemberNickname(state) {
			return state.member_nickname;
		},
		getMemberId(state) {
			return state.id;
		},
		getDevice(state) {
			return state.device;
		},
		getJoinPath(state) {
			return state.member_join_path;
		},
		getGroupPk(state) {
			return state.group_pk;
		},
		getGroupSp(state) {
			return state.group_sp;
		},
		getUserImg(state) {
			return state.user_img;
		},
	},
	actions: {
		setAuth(authInfo: StoreStateType) {
			this.member_nickname = authInfo.member_nickname;
		},
		setUserInfo(authInfo: StoreStateType) {
			this.member_name = authInfo.member_name;
			this.member_nickname = authInfo.member_nickname;
			this.member_join_path = authInfo.member_join_path;
			this.group_pk = authInfo.group_pk;
			this.group_sp = authInfo.group_sp;
		},
		setKeepLogin(authInfo: StoreStateType) {
			this.isKeepLogin = authInfo.isKeepLogin;
		},
		setId(id: string) {
			this.id = id;
		},
		setFcmToken(token: string) {
			this.fcm_token = token;
		},
		setDevice(device: string) {
			this.device = device;
		},
		setUserType(authInfo: StoreStateType) {
			this.group_pk = authInfo.group_pk;
			this.group_sp = authInfo.group_sp;
		},
		setUserImg(userImg: string) {
			this.user_img = userImg;
		},
		resetAuth() {
			this.$reset();
		},
	},
	persist: true,
});
